import { create } from "zustand";

interface UIState {
  isModelDropdownOpen: boolean;
  setModelDropdownOpen: (isOpen: boolean) => void;
}

export const useUIStore = create<UIState>((set) => ({
  isModelDropdownOpen: false,
  setModelDropdownOpen: (isOpen: boolean) =>
    set({ isModelDropdownOpen: isOpen }),
}));
